


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTREFERRALSECTION
// REJECTREFERRALSECTION


const REJECTREFERRALSECTION= createAsyncThunk(
  "rejectReferralSection/rejectReferralSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectReferralSectionSlice = createSlice({
  name: "rejectReferralSectionSlice",
  initialState: {
    rejectReferralSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectReferralSection: (state) => {
        state.rejectReferralSection.loading = false
        state.rejectReferralSection.error = false
        state.rejectReferralSection.data = []
        state.rejectReferralSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTREFERRALSECTION.fulfilled, (state, action) => {
      state.rejectReferralSection = {
        ...state.rejectReferralSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTREFERRALSECTION.pending, (state, action) => {
      state.rejectReferralSection = {
        ...state.rejectReferralSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTREFERRALSECTION.rejected, (state, action) => {
      state.rejectReferralSection = {
        ...state.rejectReferralSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectReferralSectionAction = {
    REJECTREFERRALSECTION,
};

export { rejectReferralSectionAction };
export default rejectReferralSectionSlice.reducer;
export const {setInitialStateOfrejectReferralSection} = rejectReferralSectionSlice.actions
